import { AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';

interface UnsavedSessionWarningModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onLoadWithoutSaving: () => void;
  onSaveFirst: () => void;
}

export function UnsavedSessionWarningModal({
  open,
  onOpenChange,
  onLoadWithoutSaving,
  onSaveFirst,
}: UnsavedSessionWarningModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] bg-white">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="w-5 h-5 text-yellow-600" />
            </div>
            <DialogTitle className="text-xl">Unsaved Session</DialogTitle>
          </div>
          <DialogDescription className="text-base text-gray-600">
            This is an auto-saved session that hasn't been permanently saved yet.
            If you continue without saving, this session may be overwritten by future auto-saves
            and could be lost.
          </DialogDescription>
        </DialogHeader>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 my-4">
          <p className="text-sm text-gray-700">
            <strong>Recommendation:</strong> Save this session with a permanent name before continuing
            to ensure your work is preserved.
          </p>
        </div>

        <DialogFooter className="flex gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              onLoadWithoutSaving();
            }}
            className="flex-1"
          >
            Load Without Saving
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              onSaveFirst();
            }}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white"
          >
            Save First
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
